function estimateTooltipSize(el) {
  // Estimate width: base on text length and font size
  const text = el.getAttribute('data-tooltip') || '';
  const fontSize = parseFloat(getComputedStyle(el).fontSize) || 16;
  // Estimate: 0.6em per character + padding (1em left/right)
  const width = Math.max(el.offsetWidth, text.length * fontSize * 0.6 + fontSize * 2);
  const height = fontSize * 2; // 1em top/bottom padding
  return { width, height };
}

function getTooltipRectFromPosition(el, position, offset = 8) {
  const elRect = el.getBoundingClientRect();
  const { width, height } = estimateTooltipSize(el);

  let top = 0, left = 0;
  switch (position) {
    case 'top':
      top = elRect.top - height - offset;
      left = elRect.left + (elRect.width - width) / 2;
      break;
    case 'bottom':
      top = elRect.bottom + offset;
      left = elRect.left + (elRect.width - width) / 2;
      break;
    case 'left':
      top = elRect.top + (elRect.height - height) / 2;
      left = elRect.left - width - offset;
      break;
    case 'right':
    default:
      top = elRect.top + (elRect.height - height) / 2;
      left = elRect.right + offset;
      break;
  }
  return { top, left, width, height };
}

function adjustTooltipPosition(el) {
  const positions = ['top', 'right', 'bottom', 'left'];
  let current = el.getAttribute('data-tooltip-position') || 'top';
  const tryPositions = [current, ...positions.filter(p => p !== current)];

  for (const pos of tryPositions) {
    const rect = getTooltipRectFromPosition(el, pos);
    if (
      rect.left >= 0 &&
      rect.top >= 0 &&
      rect.left + rect.width <= window.innerWidth &&
      rect.top + rect.height <= window.innerHeight
    ) {
      el.setAttribute('data-tooltip-position', pos);
      break;
    }
  }
}

function setupTooltipAutoPositioning() {
  const tooltipEls = document.querySelectorAll('[data-tooltip]');

  function handleEvent(e) {
    adjustTooltipPosition(e.currentTarget);
  }

  tooltipEls.forEach(el => {
    el.addEventListener('mouseenter', handleEvent);
    el.addEventListener('focus', handleEvent);
    window.addEventListener('resize', () => adjustTooltipPosition(el));
    window.addEventListener('scroll', () => adjustTooltipPosition(el), true);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupTooltipAutoPositioning);
} else {
  setupTooltipAutoPositioning();
}
